/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Highlight_Purpose_DescriptionInputs */



/**
* | output |
* | --- |
* | "Collaborative workspaces, granular permissions, and powerful search keep everyone aligned." |
*
* @param {Pricing_Highlight_Purpose_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_highlight_purpose_description = /** @type {((inputs?: Pricing_Highlight_Purpose_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Highlight_Purpose_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kollaborative Arbeitsbereiche, granulare Berechtigungen und leistungsstarke Suche halten alle auf dem Laufenden.")
	return /** @type {LocalizedString} */ ("Collaborative workspaces, granular permissions, and powerful search keep everyone aligned.")
});